import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { Ref } from 'vue';
import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useRecipientDetailsStore = defineStore('recipient-details-store', () => {
  const showModal = ref(false);
  const setModalVisibility = (show: boolean) => {
    showModal.value = show;
  };

  const isLoading = ref(false);
  const setIsLoading = (loading: boolean) => {
    isLoading.value = loading;
  };

  const recipientModalInfo: Ref<Recipient> = ref(null);

  const setRecipientModalInfo = (recipient: Recipient) => {
    recipientModalInfo.value = recipient;
  };

  const isEditingRecipient = ref(false);
  const setEditingRecipient = (payload: boolean) => {
    isEditingRecipient.value = payload;
  };

  return {
    showModal,
    setModalVisibility,

    isLoading,
    setIsLoading,

    recipientModalInfo,
    setRecipientModalInfo,

    isEditingRecipient,
    setEditingRecipient,
  };
});
